// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_date-picker.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for initializing and handling date picker functionality
//     for input elements in a Blazor application.
// </summary>
// ***********************************************************************

window.picker = window.picker || {};

/**
 * Initializes the date picker for the specified element using Bootstrap's datepicker.
 * The date picker is configured with specific settings and linked to a .NET method
 * to handle date selection events.
 * 
 * @function initialize
 * @memberof window.picker
 * @param {object} dotNetHelper - The .NET object reference used to invoke methods in Blazor.
 * @param {string} elementId - The ID of the input element to initialize the date picker for.
 * @returns {function} A function that, when called, destroys the date picker instance.
 */
window.picker.initialize = function (dotNetHelper, elementId) {
    const element = document.getElementById(elementId);

    $(element).datepicker({
        format: "dd M yyyy",
        autoclose: true,
        orientation: 'auto'
    }).on('changeDate', handleDateChange);

    /**
     * Handles the date change event triggered by the date picker.
     * This function retrieves the selected date and invokes a Blazor method to handle it.
     * 
     * @function handleDateChange
     * @memberof window.picker
     * @private
     * @param {object} e - The jQuery event object representing the date change event.
     */
    const handleDateChange = function (e) {
        const date = $(element).datepicker('getDate');
        dotNetHelper.invokeMethodAsync('OnDateSelected', date);
    };

    /**
     * Aligns the position of the date picker dropdown relative to the input element.
     * Ensures that the date picker is properly positioned within the viewport,
     * adjusting for screen boundaries if necessary.
     * 
     * @function alignDatePicker
     * @memberof window.picker
     * @private
     */
    const alignDatePicker = function () {
        const rect = element.getBoundingClientRect();
        const datePicker = document.querySelector('.datepicker-dropdown');
        if (datePicker) {
            datePicker.style.position = 'absolute';
            datePicker.style.top = `${rect.bottom + window.scrollY}px`;
            datePicker.style.left = `${rect.left + window.scrollX}px`;
            datePicker.style.width = 'auto';

            const datePickerRect = datePicker.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            if (datePickerRect.left < 0) {
                datePicker.style.left = '10px';
            }
            if (datePickerRect.right > viewportWidth) {
                datePicker.style.left = `${rect.right - datePickerRect.width + window.scrollX}px`;
            }
            if (datePickerRect.bottom > viewportHeight) {
                datePicker.style.top = `${rect.top - datePickerRect.height + window.scrollY}px`;
            }
        }
    };

    // Align the date picker when the input element gains focus
    element.addEventListener('focus', function() {
        setTimeout(alignDatePicker, 0);
    });

    // Return a function to destroy the date picker instance when no longer needed
    return function() {
        $(element).datepicker('destroy');
    };
};
